

    import { defineComponent, PropType, inject, computed } from 'vue';
    import { MultiFilter, MultiSelection, isMultiSelection } from '@/catalog-app/types';
    import { useStore } from '@/catalog-app/store';

    export default defineComponent({

        name: 'FilterMulti',

        props: {
            filter: {
                type: Object as PropType<MultiFilter>,
                required: true,
            }
        },

        setup(props) {

            const store = useStore();
            const state = store.state;
            const loading = inject('loading') as boolean;

            return {
                store,
                state,
                loading,
            }
        },

        computed: {
            selected: {
                get(): MultiSelection {
                    const value = this.state.selected[this.filter.name];
                    if (isMultiSelection(value)) {
                        return value;
                    } else {
                        return [];
                    }
                },
                set(value: MultiSelection) {
                    this.store.setSelectionMulti(this.filter.name, value);
                }
            }
        },
    });

